import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import {
  getBatchTabContentToPersist,
  getBatchTabIdByFormId,
} from 'state/workspaces/batch/tabContent/tabContent.selectors';
import { workspaceTabContentPersisted } from 'state/workspaces/tabContent/tabContent.actions';

export function persistBatchWorkspaceTabContentEpic(): EpicWithThunk {
  return (action$, state$, { httpClient }) =>
    action$.pipe(
      ofType(
        'NEW_BATCH_WORKSPACE_PRODUCT_SELECTED',
        'DEFAULT_BATCH_FORM_RECEIVED',
        'BATCH_FORMS_DELETED',
        'BATCH_PREVIOUS_QUOTE_LOADED',
        'BATCH_QUOTE_ACKED',
        'BATCH_QUOTE_REMOVED',
        'BATCH_QUOTE_RECEIVED',
      ),
      withLatestFrom(state$),
      mergeMap(([action, state]) => {
        const tabId =
          action.type === 'BATCH_PREVIOUS_QUOTE_LOADED' ? getBatchTabIdByFormId(state, action.formId) : action.tabId;

        if (tabId === undefined) {
          return EMPTY;
        }

        const tabContent = getBatchTabContentToPersist(state, tabId);

        if (tabContent === undefined) {
          return EMPTY;
        }

        return tabsApiConnector(httpClient, 'newBatch')
          .updateTabContent(tabId, tabContent)
          .pipe(
            map(_ => workspaceTabContentPersisted(tabId, tabContent, 'newBatch')),
            catchError((_: Error) => {
              return EMPTY;
            }),
          );
      }),
    );
}
